import { z } from "zod";

export const contactLastOrderDateSchema = z.object({
  contactId: z.number().int(),
  lastOrderDate: z.string(),
});
export const contactLastOrderDatesSchema = z.array(contactLastOrderDateSchema);
export type ContactLastOrderDate = z.infer<typeof contactLastOrderDateSchema>;

type SubmittedOrder = { contactId: number; submittedAt: string };

function keepLatest(latest: Map<number, string>, order: SubmittedOrder): Map<number, string> {
  const current = latest.get(order.contactId);
  if (current == null || order.submittedAt > current) latest.set(order.contactId, order.submittedAt);
  return latest;
}

export function latestOrderDatePerContact(orders: readonly SubmittedOrder[]): ContactLastOrderDate[] {
  const latest = orders.reduce(keepLatest, new Map<number, string>());
  return Array.from(latest, ([contactId, lastOrderDate]) => ({ contactId, lastOrderDate }));
}

export function lastOrderDateByContactId(rows: readonly ContactLastOrderDate[]): (contactId: number) => string | null {
  const byContact = new Map(rows.map((row) => [row.contactId, row.lastOrderDate]));
  return (contactId) => byContact.get(contactId) ?? null;
}
